const styles = `:host{justify-content:center;align-items:center;display:flex}`;export default styles;